import * as angular from "angular";
import {IController, IScope} from 'angular';
import {AccountModel} from "../../angular/models/account.model";
import {$accountFactory} from "../../$account.factory";

export class AccountAddMultiItemCtrl implements IController {

  accountId: string;
  isSelected: boolean;
  isDisabled: boolean;
  onToggle: Function;

  private account: AccountModel;

  /* @ngInject */
  constructor(private $account: $accountFactory, private $scope: IScope) {
  }

  $onInit() {
    if (this.accountId) {
      this.$account(this.accountId)
        .$bindCtrlToId(this.$scope, this, 'account', 'accountId');
    }
  };

  $onChanges(changes) {
    if (changes.accountId && !changes.accountId.isFirstChange()) {
      this.$onInit();
    }
  };
}


angular
  .module('bringoz.admin.accounts')
  .component('accountAddMultiItem', {
    bindings: {
      accountId: '<',
      isSelected: '<?',
      isDisabled: '<?',
      onToggle: '&'
    },
    template: require('./account-add-multi-item.html').default,
    controller: AccountAddMultiItemCtrl
  });
